import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';

@Component({
  standalone: true,
  imports: [SpinnerComponent],
  selector: 'tdv-logout-overlay',
  templateUrl: './logout-overlay.component.html',
  styleUrls: ['./logout-overlay.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutOverlayComponent {}
